<template>
  <div class="health-check-compare-box">
    <div class="health-top-btn-box">
      <div class="compare-num" v-if="healthCompareList.length >= 1">{{ healthCompareList.length }}</div>
      <el-button class="compare-btn" @click="showCompareList">
        套餐对比
        <i v-if="showCompareFlag" class="el-icon-arrow-up el-icon--right" style="font-weight: 700;"></i>
        <i v-else class="el-icon-arrow-down el-icon--right" style="font-weight: 700;"></i>
      </el-button>
    </div>
    <div class="health-list-compare-box" v-show="showCompareFlag">
      <div 
        class="health-list-compare-item" 
        v-for="item in healthCompareList" 
        :key="item.id">
        <div class="top">
          <div class="bar"></div>
          <div class="name">{{ item.mealName.length > 10 ? item.mealName.substring(0, 10) + '...' : item.mealName  }}</div>
        </div>
        <div class="bottom">
          <div class="price">
            <span class="fz14">￥</span>
            <span>{{ item.price }}</span>
          </div>
          <div class="del-icon" @click="delItemBtn(item.mealId)">
          </div>
        </div>
      </div>
      <div 
        class="health-list-compare-item compare-item-tips" 
        v-if="healthCompareList.length <= 1">
        <span 
          v-if="healthCompareList.length == 1" 
          class="compare-item--text">
          请再添加一个套餐进行对比！
        </span>
        <span 
          v-else 
          class="compare-item--text">
          请添加两个套餐进行对比！
        </span>
      </div>
      <div class="compare-bottom-btn" v-if="healthCompareList.length >= 2" @click="goComparResult">去对比</div>
      <div class="disable-compare-bottom-btn" v-else>去对比</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
  export default {
    name: 'compare',
    data() {
      return {
        showCompareFlag: false,
      }
    },
    computed: {
      // 获取 Vuex 中的对比列表
      healthCompareList() {
        return this.$store.getters.healthCompareList;
      }
    },
    mounted(){
    },
    methods:{
      showCompareList(){
        this.showCompareFlag = !this.showCompareFlag;
      },
      delItemBtn(itemId){
        this.$store.dispatch('removeFromCompareList', itemId);
      },
      goComparResult(){
        let mealIdArr = this.healthCompareList.map(item => item.mealId);
        let mealIds = mealIdArr.join(',')
        // this.$router.push({
        //   path: `ComparisonResults`,
        //   query:{
        //     mealIds: mealIds
        //   }
        // })
        window.open(
          this.$router.resolve({
            path: 'ComparisonResults',
            query: {
              mealIds: mealIds
            }
          }).href,
          '_blank' // Open in a new tab
        );

      }
    },
    
  }
</script>
<style lang="less" scoped>
.health-check-compare-box{
  z-index: 1000;
  position: fixed;
  top: 350px;
  right: 110px;
  .health-top-btn-box{
    position: relative;
    width: 228px;
    margin-bottom: 15px;
    .compare-num{
      position: absolute;
      top: -10px;
      right: 70px;
      width: 25px;
      height: 25px;
      background: #FF6600;
      border-radius: 50%;
      font-size: 12px;
      color: #FFFFFF;
      text-align: center;
      line-height: 25px;
    }
    .compare-btn{
      background-color: #09D0BC !important;
      border: 0 !important;
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      border-radius: 10px 10px 10px 10px;
      width: 148px;
      height: 57px;
    }
  }
  .health-list-compare-box{
    width: 228px;
    min-height: 194px;
    background-color: #DDF8F0;
    border-radius: 10px;
    padding: 15px;
    .health-list-compare-item{
      margin-bottom: 15px;
      width: 198px;
      height: 103px;
      background-color: #fff;
      border-radius: 10px;
      &:nth-child(2){
        .bar{
          background-color: #0BEB55 !important;
        }
      }
      &:nth-child(3){
        .bar{
          background-color: #00CBFF !important;
        }
      }
      .top{
        display: flex;
        align-items: center;
        padding: 20px 0;
        .bar{
          width: 4px;
          height: 14px;
          border-radius: 0px 2px 2px 0px;
          margin-right: 16px;
          background: #FFB300;
        }
        .name{
          font-weight: bold;
          font-size: 16px;
          color: #333333;
        }
      }
      .bottom{
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        .price{
          color: #EB3B3B;
          font-size: 22px;
          .fz14{
            font-size: 14px;
          }
        }
        .del-icon{
          width: 32px;
          height: 32px;
          cursor: pointer;
          background: url('../../assets/img/health/del-icon.png');
          &:hover{
            background: url('../../assets/img/health/del-active-icon.png');
          }
        }
      }
    }
    .compare-item-tips{
      padding: 30px 35px;
      text-align: center;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
    }
    .compare-bottom-btn{
      margin: 0 auto;
      width: 122px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: linear-gradient( 96deg, #F9E5C7 0%, #FFD595 100%);
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #FFFFFF;
      font-weight: bold;
      font-size: 18px;
      color: #AE6900;
      cursor: pointer;
    }
    .disable-compare-bottom-btn{
      margin: 0 auto;
      width: 122px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #DEDEDE;
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #FFFFFF;
      cursor: not-allowed;
    }
  }
}

</style>